export default __webpack_public_path__ + "static/media/social-twitter.4db88740.svg";